import React, { useState } from 'react';
import { mockTransactions } from '../data/mockData';
import { TransactionItem } from '../components/TransactionItem';
export function HistoryPage() {
  const [filter, setFilter] = useState<'all' | 'earned' | 'pending'>('all');
  const filteredTransactions = filter === 'all' ? mockTransactions : mockTransactions.filter(t => t.status === filter);
  return <div className="min-h-screen bg-gray-50 py-10" data-id="element-335">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-336">
        <h1 className="text-4xl font-bold text-gray-900 mb-8" data-id="element-337">
          Transaction History
        </h1>

        {/* Filters */}
        <div className="mb-8 flex space-x-4 overflow-x-auto pb-2" data-id="element-338">
          <button onClick={() => setFilter('all')} className={`px-6 py-3 rounded-full text-lg font-medium whitespace-nowrap transition-colors border-2 ${filter === 'all' ? 'bg-gray-800 text-white border-gray-800' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`} data-id="element-339">
            All Transactions
          </button>
          <button onClick={() => setFilter('earned')} className={`px-6 py-3 rounded-full text-lg font-medium whitespace-nowrap transition-colors border-2 ${filter === 'earned' ? 'bg-green-600 text-white border-green-600' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`} data-id="element-340">
            Earned
          </button>
          <button onClick={() => setFilter('pending')} className={`px-6 py-3 rounded-full text-lg font-medium whitespace-nowrap transition-colors border-2 ${filter === 'pending' ? 'bg-amber-500 text-white border-amber-500' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`} data-id="element-341">
            Pending
          </button>
        </div>

        {/* List */}
        <div className="space-y-4" data-id="element-342">
          {filteredTransactions.length > 0 ? filteredTransactions.map(transaction => <TransactionItem key={transaction.id} transaction={transaction} data-id="element-343" />) : <div className="text-center py-16 bg-white rounded-xl border border-gray-200" data-id="element-344">
              <p className="text-2xl text-gray-500" data-id="element-345">No transactions found.</p>
            </div>}
        </div>
      </div>
    </div>;
}